function sanitize(value, length, char) {
    if (! (typeof length === "number") || length < 0) {
        throw new Error("You can't pad to a negative length");
    }
    if (! (typeof char === "string") || char.length !== 1) {
        throw new Error("You must pad with a single character");
    }
    if (value == null) {
        value = "";
    }
    if (! (typeof value === "string")) {
        value = value.toString();
    }
    return value;
}

export const rightPad = (value, length, char) => {
    value = sanitize(value, length, char);
    while (value.length < length) {
        value += char;
    }
    return value;
};

export const leftPad = (value, length, char) => {
    value = sanitize(value, length, char);
    while (value.length < length) {
        value = char + value;
    }
    return value;
};




// WEBPACK FOOTER //
// ./app/lib/pad.js